const frontendUrl = import.meta.env.VITE_FRONTEND_ENDPOINT;

export const homePageAnimationStringHTML = () => {
  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Document</title>
        <style>
        * {
            padding: 0;
            margin: 0;
            box-sizing: border-box;
        }

        .mainbackground {
            height: 100vh;
            width: 100vw;
            background: linear-gradient(to bottom right, #3d065f, #160825);
            position: relative;
        }

        .logosec {
            width: 100%;
            display: flex;
            justify-content: center;
        }

        .logo {
            width: 350px;
            margin-top: -10px;
        }

        .line1 {
            width: 3px;
            background: linear-gradient(
            180deg,
            rgba(101, 28, 100, 0) 0%,
            #651c64 42%,
            #651c64 57%,
            rgba(101, 28, 100, 0) 100%
            );
            margin-top: 150px;
            height: 90vh;
        }

        .line2 {
            width: 3px;
            background: linear-gradient(
            180deg,
            rgba(101, 28, 100, 0) 9%,
            #651c64 42%,
            #651c64 57%,
            rgba(101, 28, 100, 0) 100%
            );
            height: 90vh;
        }

        .line3 {
            width: 3px;
            background: linear-gradient(
            180deg,
            rgba(101, 28, 100, 0) 16%,
            #651c64 42%,
            #651c64 57%,
            rgba(101, 28, 100, 0) 100%
            );
            margin-top: -150px;
            height: 90vh;
        }

        .lines {
            display: flex;
            justify-content: center;
        }

        .line-sec {
            width: 50px;
            display: flex;
            justify-content: space-between;
            position: absolute;
            top: 0;
            overflow: hidden;
            transform: rotate(31.15deg);
        }

        .title {
            color: white;
            font-weight: 600;
            font-size: 28px;
        }

        .maincontent {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 80px;
            height: 50vh;
        }

        .main-sec {
            width: 90vw;
            display: flex;
        }

        .content {
            width: 50%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            visibility: none;
        }

        .copy {
            color: white;
            font-size: 18px;
            font-weight: 400;
            width: 50%;
            margin-top: 30px;
            line-height: 25px;
        }
        .animation {
            mix-blend-mode: screen;
            margin-left: 150px;
        }
        .clickme {
            display: flex;
            justify-content: center;
        }

        .btnsec {
            width: 90vw;
        }
        .btnclick {
            padding: 10px 20px;
            background-color: white;
            width: 230px;
            font-size: 20px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;

            border-radius: 50px;
        }
        .btncol {
            padding: 5px;
            width: 240px;
            border-radius: 50px;
            background: linear-gradient(
            to right,
            #651c64,
            rgba(101, 28, 100, 0),
            #651c64
            );
        }

        .arrow {
            width: 4%;
            margin-left: 10px;
        }
        </style>

        <script src="https://code.createjs.com/1.0.0/createjs.min.js"></script>
        <script src="${frontendUrl}/homePage/ani.js"></script>
        <script>
        var canvas,
            stage,
            exportRoot,
            anim_container,
            dom_overlay_container,
            fnStartAnimation;
        function init() {
            canvas = document.getElementById("canvas");
            anim_container = document.getElementById("animation_container");
            dom_overlay_container = document.getElementById(
            "dom_overlay_container"
            );
            var comp = AdobeAn.getComposition("F05A2247B4829D4F8433E463DF6F7E3C");
            var lib = comp.getLibrary();
            var loader = new createjs.LoadQueue(false);
            loader.addEventListener("fileload", function (evt) {
            handleFileLoad(evt, comp);
            });
            loader.addEventListener("complete", function (evt) {
            handleComplete(evt, comp);
            });
            var lib = comp.getLibrary();
            loader.loadManifest(lib.properties.manifest);
        }
        function handleFileLoad(evt, comp) {
            var images = comp.getImages();
            if (evt && evt.item.type == "image") {
            images[evt.item.id] = evt.result;
            }
        }
        function handleComplete(evt, comp) {
            //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
            var lib = comp.getLibrary();
            var ss = comp.getSpriteSheet();
            var queue = evt.target;
            var ssMetadata = lib.ssMetadata;
            for (i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new createjs.SpriteSheet({
                images: [queue.getResult(ssMetadata[i].name)],
                frames: ssMetadata[i].frames,
            });
            }
            exportRoot = new lib.adp();
            stage = new lib.Stage(canvas);
            //Registers the "tick" event listener.
            fnStartAnimation = function () {
            stage.addChild(exportRoot);
            createjs.Ticker.framerate = lib.properties.fps;
            createjs.Ticker.addEventListener("tick", stage);
            };
            //Code to support hidpi screens and responsive scaling.
            AdobeAn.makeResponsive(false, "both", false, 1, [
            canvas,
            anim_container,
            dom_overlay_container,
            ]);
            AdobeAn.compositionLoaded(lib.properties.id);
            fnStartAnimation();
        }

        document.addEventListener("DOMContentLoaded", function () {
            var targetDiv = document.querySelector(".animation");
            if (targetDiv) {
            init();
            }
        });
        </script>
    </head>
    <body>
        <div class="mainbackground">
        <div class="logosec">
            <img class="logo" src="${frontendUrl}/homePage/logo.png" />
        </div>
        <div class="lines">
            <div class="line-sec">
            <div class="line1"></div>
            <div class="line2"></div>
            <div class="line3"></div>
            </div>
        </div>
        <div class="maincontent">
            <div class="main-sec">
            <div class="content">
                <div class="title"></div>
                <div class="copy"></div>
            </div>
            <div class="animation">
                <div
                id="animation_container"
                style="
                    background-color: rgba(255, 255, 255, 0);
                    width: 720px;
                    height: 660px;
                "
                >
                <canvas
                    id="canvas"
                    width="720"
                    height="660"
                    style="
                    position: absolute;
                    display: block;
                    background-color: rgba(255, 255, 255, 0);
                    "
                ></canvas>
                <div
                    id="dom_overlay_container"
                    style="
                    pointer-events: none;
                    overflow: hidden;
                    width: 720px;
                    height: 660px;
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    display: block;
                    "
                ></div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </body>
    </html>
    `;
};
